import axios from '../axios'
// 资源分类列表
export const getBannerList = (data) => {
  return axios({
    url: '/con/banner/getBannerList',
    method: 'POST',
    data
  })
}
export const editBanner = (data) => {
  return axios({
    url: '/con/banner/editBanner',
    method: 'POST',
    data
  })
}
export const updateStatus = (data) => {
  return axios({
    url: '/con/banner/updateStatus',
    method: 'POST',
    data
  })
}
export const removeBanner = (data) => {
  return axios({
    url: '/con/banner/remove',
    method: 'POST',
    data
  })
}
export const createBanner = (data) => {
  return axios({
    url: '/con/banner/createBanner',
    method: 'POST',
    data
  })
}





// WEBPACK FOOTER //
// ./src/http/moudules/bannerManage.js